'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useLandingPageEmailTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.LANDING_PAGE_EMAIL_FILLED,
      properties: props,
      opts: { shouldSendToFacebook: true },
    },
    autoTrack,
  );
};
